const minin = {
  data() {
    return {
      formOpen: false,
      form: {
        repaytime: null,
        istime: '2',
        inton: undefined,
        unton: undefined,
      },
      // 基础信息
      formCtrl: [
        {
          label: "运单编号",
          keyName: "order_num",
          err: "请填写运单编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
          viewMode: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "货物名称",
          keyName: "name",
          err: "请填写货物名称",
          type: "text",
          viewMode: true,
        },
      ],
      // 装货信息
      formCtrlIn: [
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货联系人",
          keyName: "drman",
          err: "请填写装货联系人",
          type: "text",
          viewMode: true,
        },
        {
          label: "联系方式",
          keyName: "drtel",
          err: "请填写联系方式",
          type: "text",
          viewMode: true,
        },
        {
          keyName: "predict_loading_date",
          label: "装货日期",
          err: "请选择装货日期",
          type: "date",
          viewMode: true,
        },
      ],
      // 卸货信息
      formCtrlOut: [
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货联系人",
          keyName: "enman",
          err: "请填写卸货联系人",
          type: "text",
          viewMode: true,
        },
        {
          label: "联系方式",
          keyName: "ertel",
          err: "请填写联系方式",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货日期",
          keyName: "predict_unloading_date",
          err: "请选择卸货日期",
          type: "date",
          viewMode: true,
        },
      ],
      // 运单信息
      formCtrlOrder: [
        {
          label: "计价方式",
          // keyName: "pricingname",
          keyName: "pricing",
          type: "select",
          options: [
            { label: '按重量计费（元/吨）', value: 1 },
            { label: '按体积计费（元/立方米）', value: 2, },
            { label: '按件数计费（元/件）', value: 3, },
            //{ label: '按里程计费（元/公里）', value: 4, },
            { label: '按趟计费（元/趟）', value: 5, },
          ],
          viewMode: true,
        },
        {
          label: "公司单价",
          keyName: "cprice",
          err: "请填写公司单价",
          type: "number",
          viewMode: true,
        },
        {
          label: "司机单价",
          keyName: "dprice",
          err: "请填写司机单价",
          type: "number",
          viewMode: true,
        },
        {
          label: "装货量",
          keyName: "inton",
          err: "请填写装货量",
          type: "text",
        },
        {
          label: "卸货量",
          keyName: "unton",
          err: "请填写卸货量",
          type: "text",
        },
      ],
      kuitonCtrl: {
        label: "亏吨重量（吨）",
        keyName: "kuiton",
        err: "请填写亏吨重量",
        type: "text",
        viewMode: true,
      },
      formCtrlOrder2: [
        {
          label: "装货单",
          keyName: "invoice",
          err: "请填写装货单",
          type: "file",
          ptype: "order",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 1,
        },
        {
          label: "卸货单",
          keyName: "uninvoice",
          err: "请填写卸货单",
          type: "file",
          ptype: "order",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          className: "unton",
          max: 1,
        },
      ],
      // 亏吨信息
      formCtrlWeight: [
        // {
        //   label: "计算重量（吨）",
        //   keyName: "caton",
        //   err: "请填写计算重量",
        //   type: "text",
        //   tips: "不填写则默认卸货重量为计算重量",
        // },
        {
          label: "客担亏吨（吨）",
          keyName: "ceton",
          err: "请填写客担亏吨",
          type: "number",
        },
        {
          label: "亏吨单价（元/吨）",
          keyName: "dtonprice",
          err: "请填写亏吨单价",
          type: "number",
          tips: "不填写默认不计算亏吨金额",
        },
        // {
        //   label: "实际客户承担亏吨",
        //   keyName: "dceton",
        //   err: "请填写实际客户承担亏吨",
        //   type: "number",
        //   tips: "不填写无法计算出实际运费",
        // },
        // {
        //   label: "实际亏吨单价（元/吨）",
        //   keyName: "dtonprices",
        //   err: "请填写实际亏吨单价",
        //   type: "number",
        //   tips: "不填写无法计算出实际运费",
        // },
      ],
      // 预计结款日期
      formCtrl2: [
        {
          label: "预计结款日期",
          keyName: "repaytime",
          err: "请填写预计结款日期",
          type: "date",
          tips: "不填写则默认没有预计结款日期",
        },
      ],
      istimeCtrl: {
        label: "结款提醒",
        keyName: "istime_name",
        type: "text",
        viewMode: true,
      },
      // 运单备注
      formCtrl3: [
        {
          label: "运单备注",
          keyName: "order_remark",
          className: "order_remark",
          err: "请填写运单备注",
          // type: "text",
          type: "textarea",
        },
      ],
      formCtrlfee: [
        {
          label: "信息费",
          keyName: "message",
          type: "number",
        },
        {
          label: "保险费",
          keyName: "premium",
          type: "number",
        },
        {
          label: "燃油附加费",
          keyName: "fuel",
          type: "number",
        },
        {
          label: "超限附加费",
          keyName: "overlimit",
          type: "number",
        },
      ],
      showRoute: false,
      routeCtrl: {
        label: "路线选择",
        keyName: "routeID",
        type: "select",
        options: [],
      },
      routeList: [],
      routeID: null,
      custom: [],
      product: [],
    };
  },
  methods: {
    handleChange() {
      this.formOpen = !this.formOpen;
    },
    updateStatus() {
      this.$confirm('确认审核通过吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateStatusReq();
      }).catch(() => { });
    },
    updateStatusReq() {
      this.loading = true
      let url = `${this.baseUrl}/updatestatus`;
      const params = {
        userid: this.user.id,
        id: this.id,
        ...this.form,
        isstatus: 4,
      }
      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '审核通过!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '审核通过失败，请稍后重试！'
        });
      })
    },
    checkInTon(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      if (value == undefined || value == '') {
        callback(new Error('请填写装货重量'));
      }
      // else if (Number(value) > 60) {
      //   callback(new Error('重量不能超过60吨'));
      // }
      else {
        callback();
      }
    },
    checkUnTon(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      if (value == undefined || value == '') {
        callback(new Error('请填写卸货重量'));
      }
      // else if (Number(value) > 60) {
      //   callback(new Error('重量不能超过60吨'));
      // }
      else {
        callback();
      }
    },
    onToggle(boo) {
      // console.log(boo)
      boo ? (this.$set(this.form, 'istime', 1)) : (this.$set(this.form, 'istime', 2))
      // console.log('form', { ...this.form })
    },
    setDetail() {
      const formCtrl = this.getAllCtrls()
      this.detailHandler(formCtrl)
    },
    getAllCtrls() {
      const formCtrl = [...this.formCtrl]
      if (this.kuitonCtrl) {
        formCtrl.push(this.kuitonCtrl)
      }
      const In = this.formCtrlIn
      if (In && In.length) {
        formCtrl.push(...In)
      }
      const Out = this.formCtrlOut
      if (Out && Out.length) {
        formCtrl.push(...Out)
      }
      const Order = this.formCtrlOrder
      if (Order && Order.length) {
        formCtrl.push(...Order)
      }
      const Order2 = this.formCtrlOrder2
      if (Order2 && Order2.length) {
        formCtrl.push(...Order2)
      }
      const Weight = this.formCtrlWeight
      if (Weight && Weight.length) {
        formCtrl.push(...Weight)
      }
      const f2 = this.formCtrl2
      if (f2 && f2.length) {
        formCtrl.push(...f2)
      }
      const f3 = this.formCtrl3
      if (f3 && f3.length) {
        formCtrl.push(...f3)
      }
      const fee = this.formCtrlfee
      if (fee && fee.length) {
        formCtrl.push(...fee)
      }
      return formCtrl
    },
    detailHandler(formCtrl) {
      formCtrl.map(v => {
        const key = v.keyName
        // console.log(key)
        // if (['shname'].includes(key) && this.detail['shtel']) {
        //   this.form[key] = `${this.detail[key]}:${this.detail['shtel']}`;
        // } else if (['drman'].includes(key) && this.detail['drtel']) {
        //   this.form[key] = `${this.detail[key]}:${this.detail['drtel']}`;
        // } else if (['enman'].includes(key) && this.detail['ertel']) {
        //   this.form[key] = `${this.detail[key]}:${this.detail['ertel']}`;
        // } else
        // console.log(v)
        if (['kuiton'].includes(key) && v.viewMode) {
          this.form[key] = `${this.detail[key]}吨`;
        } else if (['message'].includes(key) && v.viewMode) {
          // console.log(v)
          this.form[key] = `${this.detail[key]}元`;
        } else if (key === 'repaytime') {
          if (this.detail[key] != '0000-00-00') {
            this.form[key] = this.detail[key];
          }
        } else if (['order_remark'].includes(key)) {
          // console.log(v)
          // console.log(this.detail[key])
          this.$set(this.form, key, this.detail[key])
          this.$nextTick(() => {
            // console.log(this.$refs)
            if (this.$refs && this.$refs.form3Item0) {
              const dom = this.$refs.form3Item0[0].$el
              // console.log(dom)
              const inner = dom.querySelector('.el-textarea__inner')
              if (!inner) return
              // console.log(inner)
              // console.log(inner.scrollHeight)
              inner.style.height = 'auto'; // 重置高度
              inner.style.height = inner.scrollHeight + 'px'; // 设置为内容高度
            }
          })
        } else {
          this.form[key] = this.detail[key];
        }
      })
      // 货物id，提交时需要回传
      this.form['nid'] = this.detail['nid'];
      this.form['id'] = this.detail['id'];
      if (this.form['repaytime']) {
        this.$set(this.form, 'istime', this.detail['istime'])
      }
      if (this.form['istime'] == 1) {
        this.$set(this.form, 'istime_name', '开启')
      } else {
        this.$set(this.form, 'istime_name', '关闭')
      }
      this.$forceUpdate()
      console.log('detail', { ...this.detail })
      console.log('form', { ...this.form })
    },
    paramsPackageHandler(params) {
      // console.log('params', { ...params })
      const keys = ['nid', 'shipperid', 'carid', 'istime']
      const form = this.form
      for (const key in form) {
        if (Object.hasOwnProperty.call(form, key) && keys.includes(key)) {
          // console.log(key, object[key], typeof object[key])
          const value = form[key]
          // console.log(value)
          if (typeof value === 'string' && value.includes('元')) {
            params[key] = value.replace('元', '')
          } else {
            params[key] = value;
          }
        }
      }
      keys.map(v => {
        if (!params[v]) {
          params[v] = this.detail[v]
        }
      })
      delete params['istime_name']
      // console.log({...params})
    },
    onInput({ key, value }) {
      console.log(key, value)
      if (key === 'order_remark') {
        if (this.$refs && this.$refs.form3Item0) {
          const dom = this.$refs.form3Item0[0].$el
          // console.log(dom)
          const inner = dom.querySelector('.el-textarea__inner')
          if (!inner) return
          // console.log(inner)
          // console.log(inner.scrollHeight)
          // const oheight = inner.scrollHeight
          inner.style.height = 'auto'; // 重置高度
          // 高度设为auto后scrollHeight会改变，用原始高度判断，一行时强制一行高度，其他情况随内容升高
          // if (oheight < 55) {
          //   inner.style.height = 40 + 'px'
          // } else {
          inner.style.height = inner.scrollHeight + 'px'; // 设置为内容高度
          // }
        }
      }
    },
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      if (key === 'name') {
        this.form[key] = value
        // console.log(value)
        // console.log(this.form[key])
        this.product.map(v => {
          if (v.name === value) {
            this.form['nid'] = v.id
          }
        })
      } else if (key === 'shname') {
        this.form[key] = value
        // console.log(value)
        // console.log(this.form[key])
        this.custom.map(v => {
          if (v.name + '-' + v.member === value) {
            this.form['shipperid'] = v.id
            this.routeID = null
            this.getCustomRoute(v.id)
          }
        })
      } else if (key === 'shipperid') {
        this.form[key] = value
        // console.log(value)
        // console.log(this.routeID)
        this.routeID = null
        // console.log(this.routeID)
        this.getCustomRoute(value)
        // console.log(this.form[key])
      } else if (['invoice', 'uninvoice'].includes(key) && value.length == 1 && value[0] && value[0].response) {
        this.form[key] = value[0].response.photo
        // console.log(this.form[key])
      } else if (['identitycard', 'driverslicense', 'certificate', 'escortcard'].includes(key) || key.includes('photo') || (value && typeof value === 'object')) {
        this.form[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
      } else {
        this.form[key] = value;
      }
      // 表单赋值之后再计算亏吨重量
      if (['inton', 'unton'].includes(key)) {
        this.calcKuiton()
      }
      // console.log({ ...this.form });
    },
    getCustomRoute(custom_id) {
      let url = `custom/custom_route_rec`;
      const params = {
        userid: this.user.id,
        custom_id,
      }
      this.post(url, params, ({ msg, data }) => {
        if (msg == 'success' && data && data.length) {
          this.showRoute = true
          this.routeList = [...data]
          this.routeCtrl.options = data.map(v => {
            return {
              label: v.route_name,
              value: v.id,
            }
          })
        } else {
          this.showRoute = false
          this.routeList = []
          this.routeCtrl.options = []
        }
      }, err => {
        console.log(err)
      })
    },
    onRouteChange({ value }) {
      // console.log(value)
      // console.log(this.routeID)
      // 这一步才能触发双向绑定
      this.routeID = value
      // console.log(this.routeID)
      this.routeList.map(v => {
        if (v.id == value) {
          this.form['coaddress'] = v['coaddress']
          this.form['drman'] = v['drman']
          this.form['drtel'] = v['drtel']
          this.form['enaddress'] = v['enaddress']
          this.form['enman'] = v['enman']
          this.form['ertel'] = v['ertel']
        }
      })
    },
    calcKuiton() {
      const inton = this.form['inton'];
      const unton = this.form['unton'];
      // console.log(inton, unton)
      if (inton && unton) {
        this.form['kuiton'] = (inton - unton).toFixed(2) + '吨'
      }
    },
  },
}

export default minin